import { FontType } from "game-engine/types";

const FontMini: FontType = {
  letterSpacing: 1,
  lineSpacing: -2,
  lineHeight: 10,
  underlineHeight: 2,
  glyphs: {
    " ": {
      pixels: [[0, 0, 0, 0, 0]],
    },
    a: {
      pixels: [
        [0, 1, 1],
        [1, 0, 1],
        [0, 1, 1],
      ],
    },
    á: {
      pixels: [
        [0, 0, 1],
        [0, 0, 0],
        [0, 1, 1],
        [1, 0, 1],
        [0, 1, 1],
      ],
    },
    b: {
      pixels: [
        [1, 0, 0],
        [1, 1, 0],
        [1, 0, 1],
        [1, 1, 0],
      ],
    },
    c: {
      pixels: [
        [0, 1],
        [1, 0],
        [1, 1],
      ],
    },
    č: {
      pixels: [
        [1, 1],
        [0, 0],
        [0, 1],
        [1, 0],
        [1, 1],
      ],
    },
    d: {
      pixels: [
        [0, 0, 1],
        [0, 1, 1],
        [1, 0, 1],
        [0, 1, 1],
      ],
    },
    ď: {
      pixels: [
        [0, 0, 1, 1],
        [0, 1, 1, 0],
        [1, 0, 1, 0],
        [0, 1, 1, 0],
      ],
    },
    e: {
      pixels: [
        [0, 1, 1],
        [1, 1, 0],
        [0, 1, 1],
      ],
    },
    é: {
      pixels: [
        [0, 0, 1],
        [0, 0, 0],
        [0, 1, 1],
        [1, 1, 0],
        [0, 1, 1],
      ],
    },
    ě: {
      pixels: [
        [0, 1, 1],
        [0, 0, 0],
        [0, 1, 1],
        [1, 1, 0],
        [0, 1, 1],
      ],
    },
    f: {
      pixels: [
        [0, 0, 1],
        [0, 1, 0],
        [1, 1, 1],
        [0, 1, 0],
      ],
    },
    g: {
      offsetY: -2,
      pixels: [
        [0, 1, 1],
        [1, 0, 1],
        [0, 1, 1],
        [0, 0, 1],
        [0, 1, 0],
      ],
    },
    h: {
      pixels: [
        [1, 0, 0],
        [1, 1, 0],
        [1, 0, 1],
        [1, 0, 1],
      ],
    },
    i: {
      pixels: [
        [1], //
        [0], //
        [1], //
        [1], //
      ],
    },
    í: {
      pixels: [
        [1], //
        [1], //
        [0], //
        [1], //
        [1], //
      ],
    },
    j: {
      offsetY: -2,
      pixels: [
        [0, 1],
        [0, 0],
        [0, 1],
        [0, 1],
        [0, 1],
        [1, 0],
      ],
    },
    k: {
      pixels: [
        [1, 0, 0],
        [1, 0, 1],
        [1, 1, 0],
        [1, 0, 1],
      ],
    },
    l: {
      pixels: [
        [1], //
        [1], //
        [1], //
        [1], //
      ],
    },
    m: {
      pixels: [
        [1, 1, 1, 1, 0],
        [1, 0, 1, 0, 1],
        [1, 0, 1, 0, 1],
      ],
    },
    n: {
      pixels: [
        [1, 1, 0],
        [1, 0, 1],
        [1, 0, 1],
      ],
    },
    ň: {
      pixels: [
        [0, 1, 1],
        [0, 0, 0],
        [1, 1, 0],
        [1, 0, 1],
        [1, 0, 1],
      ],
    },
    o: {
      pixels: [
        [0, 1, 1],
        [1, 0, 1],
        [1, 1, 0],
      ],
    },
    ó: {
      pixels: [
        [0, 0, 1],
        [0, 0, 0],
        [0, 1, 1],
        [1, 0, 1],
        [1, 1, 0],
      ],
    },
    p: {
      offsetY: -2,
      pixels: [
        [1, 1, 0],
        [1, 0, 1],
        [1, 1, 0],
        [1, 0, 0],
        [1, 0, 0],
      ],
    },
    q: {
      offsetY: -2,
      pixels: [
        [0, 1, 1],
        [1, 0, 1],
        [0, 1, 1],
        [0, 0, 1],
        [0, 0, 1],
      ],
    },
    r: {
      pixels: [
        [1, 1],
        [1, 0],
        [1, 0],
      ],
    },
    ř: {
      pixels: [
        [1, 1],
        [0, 0],
        [1, 1],
        [1, 0],
        [1, 0],
      ],
    },
    s: {
      pixels: [
        [1, 1],
        [1, 0],
        [1, 1],
      ],
    },
    š: {
      pixels: [
        [1, 1],
        [0, 0],
        [1, 1],
        [1, 0],
        [1, 1],
      ],
    },
    t: {
      pixels: [
        [0, 1, 0],
        [1, 1, 1],
        [0, 1, 0],
        [0, 1, 0],
      ],
    },
    ť: {
      pixels: [
        [0, 1, 0, 1],
        [1, 1, 1, 0],
        [0, 1, 0, 0],
        [0, 1, 0, 0],
      ],
    },
    u: {
      pixels: [
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 1],
      ],
    },
    ú: {
      pixels: [
        [0, 0, 1],
        [0, 0, 0],
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 1],
      ],
    },
    ů: {
      pixels: [
        [0, 1, 0],
        [0, 0, 0],
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 1],
      ],
    },
    v: {
      pixels: [
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 0],
      ],
    },
    w: {
      pixels: [
        [1, 0, 1, 0, 1],
        [1, 0, 1, 0, 1],
        [0, 1, 0, 1, 0],
      ],
    },
    x: {
      pixels: [
        [1, 0, 1],
        [0, 1, 0],
        [1, 0, 1],
      ],
    },
    y: {
      offsetY: -2,
      pixels: [
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 1],
        [0, 0, 1],
        [0, 1, 0],
      ],
    },
    ý: {
      offsetY: -2,
      pixels: [
        [0, 0, 1],
        [0, 0, 0],
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 1],
        [0, 0, 1],
        [0, 1, 0],
      ],
    },
    z: {
      pixels: [
        [1, 1],
        [0, 1],
        [1, 1],
      ],
    },
    ž: {
      pixels: [
        [1, 1],
        [0, 0],
        [1, 1],
        [0, 1],
        [1, 1],
      ],
    },
    A: {
      pixels: [
        [0, 1, 0],
        [1, 0, 1],
        [1, 1, 1],
        [1, 0, 1],
      ],
    },
    Á: {
      pixels: [
        [0, 0, 1],
        [0, 0, 0],
        [0, 1, 0],
        [1, 0, 1],
        [1, 1, 1],
        [1, 0, 1],
      ],
    },
    B: {
      pixels: [
        [1, 1, 0],
        [1, 1, 1],
        [1, 0, 1],
        [1, 1, 1],
      ],
    },
    C: {
      pixels: [
        [0, 1, 1],
        [1, 0, 0],
        [1, 0, 0],
        [0, 1, 1],
      ],
    },
    Č: {
      pixels: [
        [0, 1, 1],
        [0, 0, 0],
        [0, 1, 1],
        [1, 0, 0],
        [1, 0, 0],
        [0, 1, 1],
      ],
    },
    D: {
      pixels: [
        [1, 1, 0],
        [1, 0, 1],
        [1, 0, 1],
        [1, 1, 0],
      ],
    },
    Ď: {
      pixels: [
        [0, 1, 1],
        [0, 0, 0],
        [1, 1, 0],
        [1, 0, 1],
        [1, 0, 1],
        [1, 1, 0],
      ],
    },
    E: {
      pixels: [
        [1, 1, 1],
        [1, 1, 0],
        [1, 0, 0],
        [1, 1, 1],
      ],
    },
    É: {
      pixels: [
        [0, 0, 1],
        [0, 0, 0],
        [1, 1, 1],
        [1, 1, 0],
        [1, 0, 0],
        [1, 1, 1],
      ],
    },
    Ě: {
      pixels: [
        [0, 1, 1],
        [0, 0, 0],
        [1, 1, 1],
        [1, 1, 0],
        [1, 0, 0],
        [1, 1, 1],
      ],
    },
    F: {
      pixels: [
        [1, 1, 1],
        [1, 0, 0],
        [1, 1, 0],
        [1, 0, 0],
      ],
    },
    G: {
      pixels: [
        [0, 1, 1, 0],
        [1, 0, 0, 0],
        [1, 0, 1, 1],
        [0, 1, 1, 0],
      ],
    },
    H: {
      pixels: [
        [1, 0, 1],
        [1, 1, 1],
        [1, 0, 1],
        [1, 0, 1],
      ],
    },
    I: {
      pixels: [
        [1, 1, 1],
        [0, 1, 0],
        [0, 1, 0],
        [1, 1, 1],
      ],
    },
    Í: {
      pixels: [
        [0, 0, 1],
        [0, 0, 0],
        [1, 1, 1],
        [0, 1, 0],
        [0, 1, 0],
        [1, 1, 1],
      ],
    },
    J: {
      pixels: [
        [1, 1, 1],
        [0, 1, 0],
        [0, 1, 0],
        [1, 0, 0],
      ],
    },
    K: {
      pixels: [
        [1, 0, 1],
        [1, 1, 0],
        [1, 0, 1],
        [1, 0, 1],
      ],
    },
    L: {
      pixels: [
        [1, 0, 0],
        [1, 0, 0],
        [1, 0, 0],
        [1, 1, 1],
      ],
    },
    M: {
      pixels: [
        [1, 0, 1, 1],
        [1, 1, 0, 1],
        [1, 0, 0, 1],
        [1, 0, 0, 1],
      ],
    },
    N: {
      pixels: [
        [1, 0, 0, 1],
        [1, 1, 0, 1],
        [1, 0, 1, 1],
        [1, 0, 0, 1],
      ],
    },
    Ň: {
      pixels: [
        [0, 1, 1, 0],
        [0, 0, 0, 0],
        [1, 0, 0, 1],
        [1, 1, 0, 1],
        [1, 0, 1, 1],
        [1, 0, 0, 1],
      ],
    },
    O: {
      pixels: [
        [0, 1, 1, 0],
        [1, 0, 0, 1],
        [1, 0, 0, 1],
        [0, 1, 1, 0],
      ],
    },
    Ó: {
      pixels: [
        [0, 0, 1, 0],
        [0, 0, 0, 0],
        [0, 1, 1, 0],
        [1, 0, 0, 1],
        [1, 0, 0, 1],
        [0, 1, 1, 0],
      ],
    },
    P: {
      pixels: [
        [1, 1, 0],
        [1, 0, 1],
        [1, 1, 0],
        [1, 0, 0],
      ],
    },
    Q: {
      pixels: [
        [0, 1, 1, 0],
        [1, 0, 0, 1],
        [1, 0, 1, 1],
        [0, 1, 1, 1],
      ],
    },
    R: {
      pixels: [
        [1, 1, 0],
        [1, 0, 1],
        [1, 1, 0],
        [1, 0, 1],
      ],
    },
    Ř: {
      pixels: [
        [0, 1, 1],
        [0, 0, 0],
        [1, 1, 0],
        [1, 0, 1],
        [1, 1, 0],
        [1, 0, 1],
      ],
    },
    S: {
      pixels: [
        [1, 1],
        [1, 0],
        [0, 1],
        [1, 1],
      ],
    },
    Š: {
      pixels: [
        [1, 1],
        [0, 0],
        [1, 1],
        [1, 0],
        [0, 1],
        [1, 1],
      ],
    },
    T: {
      pixels: [
        [1, 1, 1],
        [0, 1, 0],
        [0, 1, 0],
        [0, 1, 0],
      ],
    },
    Ť: {
      pixels: [
        [0, 1, 1],
        [0, 0, 0],
        [1, 1, 1],
        [0, 1, 0],
        [0, 1, 0],
        [0, 1, 0],
      ],
    },
    U: {
      pixels: [
        [1, 0, 1],
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 1],
      ],
    },
    Ú: {
      pixels: [
        [0, 0, 1],
        [0, 0, 0],
        [1, 0, 1],
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 1],
      ],
    },
    Ů: {
      pixels: [
        [0, 1, 0],
        [0, 0, 0],
        [1, 0, 1],
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 1],
      ],
    },
    V: {
      pixels: [
        [1, 0, 1],
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 0],
      ],
    },
    W: {
      pixels: [
        [1, 0, 1, 0, 1],
        [1, 0, 1, 0, 1],
        [1, 0, 1, 0, 1],
        [0, 1, 0, 1, 0],
      ],
    },
    X: {
      pixels: [
        [1, 0, 1],
        [0, 1, 0],
        [1, 0, 1],
        [1, 0, 1],
      ],
    },
    Y: {
      pixels: [
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 0],
        [0, 1, 0],
      ],
    },
    Ý: {
      pixels: [
        [0, 0, 1],
        [0, 0, 0],
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 0],
        [0, 1, 0],
      ],
    },
    Z: {
      pixels: [
        [1, 1],
        [0, 1],
        [1, 0],
        [1, 1],
      ],
    },
    Ž: {
      pixels: [
        [1, 1],
        [0, 0],
        [1, 1],
        [0, 1],
        [1, 0],
        [1, 1],
      ],
    },
    0: {
      pixels: [
        [0, 1, 0],
        [1, 0, 1],
        [1, 0, 1],
        [0, 1, 0],
      ],
    },
    1: {
      pixels: [
        [0, 1, 0],
        [1, 1, 0],
        [0, 1, 0],
        [1, 1, 1],
      ],
    },
    2: {
      pixels: [
        [1, 1, 0],
        [0, 0, 1],
        [0, 1, 0],
        [1, 1, 1],
      ],
    },
    3: {
      pixels: [
        [1, 1, 1],
        [0, 1, 0],
        [0, 0, 1],
        [1, 1, 0],
      ],
    },
    4: {
      pixels: [
        [1, 0, 1, 0],
        [1, 0, 1, 0],
        [1, 1, 1, 1],
        [0, 0, 1, 0],
      ],
    },
    5: {
      pixels: [
        [1, 1, 1],
        [1, 1, 0],
        [0, 0, 1],
        [1, 1, 0],
      ],
    },
    6: {
      pixels: [
        [0, 1, 1],
        [1, 1, 0],
        [1, 0, 1],
        [1, 1, 0],
      ],
    },
    7: {
      pixels: [
        [1, 1, 1],
        [0, 0, 1],
        [0, 1, 0],
        [0, 1, 0],
      ],
    },
    8: {
      pixels: [
        [0, 1, 1, 0],
        [1, 0, 1, 0],
        [0, 1, 0, 1],
        [0, 1, 1, 0],
      ],
    },
    9: {
      pixels: [
        [0, 1, 0],
        [1, 0, 1],
        [0, 1, 1],
        [1, 1, 0],
      ],
    },
    ".": {
      pixels: [
        [1], //
      ],
    },
    ",": {
      offsetY: -1,
      pixels: [
        [0, 1, 1],
        [0, 1, 1],
        [1, 1, 0],
      ],
    },
    "!": {
      pixels: [
        [1], //
        [1], //
        [0], //
        [1], //
      ],
    },
    "?": {
      pixels: [
        [1, 1],
        [0, 1],
        [0, 0],
        [1, 0],
      ],
    },
    ":": {
      pixels: [
        [1], //
        [0], //
        [1], //
      ],
    },
    ";": {
      offsetY: -1,
      pixels: [
        [1], //
        [0], //
        [1], //
        [1], //
      ],
    },
    "'": {
      pixels: [
        [1], //
        [1], //
        [0], //
        [0], //
      ],
    },
    '"': {
      pixels: [
        [1], //
        [1], //
        [0], //
        [0], //
      ],
    },
    "(": {
      pixels: [
        [0, 1],
        [1, 0],
        [1, 0],
        [0, 1],
      ],
    },
    ")": {
      pixels: [
        [1, 0],
        [0, 1],
        [0, 1],
        [1, 0],
      ],
    },
    "[": {
      pixels: [
        [1, 1],
        [1, 0],
        [1, 0],
        [1, 1],
      ],
    },
    "]": {
      pixels: [
        [1, 1],
        [0, 1],
        [0, 1],
        [1, 1],
      ],
    },
    "{": {
      pixels: [
        [0, 1, 1],
        [1, 1, 0],
        [0, 1, 0],
        [0, 1, 1],
      ],
    },
    "}": {
      pixels: [
        [1, 1, 0],
        [0, 1, 1],
        [0, 1, 0],
        [1, 1, 0],
      ],
    },
    "+": {
      pixels: [
        [0, 1, 0],
        [1, 1, 1],
        [0, 1, 0],
      ],
    },
    "-": {
      pixels: [
        [1, 1],
        [0, 0],
      ],
    },
    "*": {
      pixels: [
        [1, 0, 1],
        [0, 1, 0],
        [1, 0, 1],
      ],
    },
    "/": {
      pixels: [
        [0, 1],
        [0, 1],
        [1, 0],
        [1, 0],
      ],
    },
    "=": {
      pixels: [
        [1, 1],
        [0, 0],
        [1, 1],
      ],
    },
    "<": {
      pixels: [
        [0, 1],
        [1, 0],
        [0, 1],
      ],
    },
    ">": {
      pixels: [
        [1, 0],
        [0, 1],
        [1, 0],
      ],
    },
    "↑": {
      pixels: [
        [0, 1, 0],
        [1, 1, 1],
        [0, 1, 0],
        [0, 1, 0],
      ],
    },
    "↓": {
      pixels: [
        [0, 1, 0],
        [0, 1, 0],
        [1, 1, 1],
        [0, 1, 0],
      ],
    },
    "␃": {
      offsetY: -1,
      color: `#ffff3c`,
      pixels: [
        [1, 1, 1],
        [1, 1, 1],
        [1, 1, 1],
        [1, 1, 1],
        [1, 1, 1],
        [1, 1, 1],
      ],
    },
  },
};

export default FontMini;
